<style></style>

<template>
  <div>
    <h1 class="font-weight-bold text-uppercase">Planos de Profissionais</h1>
    <hr class="linha-amarela" />
    <form>
      <ProfessionalPlanCard
        v-for="(plan, index) in professionalPlans"
        :key="index"
        :pPlanData="plan"
      />
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProfessionalPlanCard from '../../components/Admin/ProfessionalPlanCard';

export default {
  components: {
    ProfessionalPlanCard,
  },
  data: () => ({}),
  computed: {
    ...mapState({
      professionalPlans: (state) => state.professionalPlans,
    }),
  },
  created() {
    this.$store.dispatch('loadProfessionalPlans');
  },
};
</script>
